"use client"

import { Typography } from "@/shared/ui/atoms"
import type { PartnerHospitalSchedule } from "@/entities/hospital/api/types"

import { useHospitalSchedule } from "@/widgets/hospital-detail/lib/useHospitalOpenState"

interface HospitalScheduleTableProps {
  weeklySchedules: PartnerHospitalSchedule[]
}

const stripDaySuffix = (day: string) => day.replace("요일", "")

/**
 * 요일별 진료시간 표.
 *
 * 개편 전에는 오늘 한 줄만 보이고 나머지 6일은 눌러야 펼쳐졌다 —
 * 즉 초기 HTML(크롤러가 읽는 본문)에는 하루치만 있었다. 병원마다 다른 정보인데
 * 접어 둘 이유가 없어 항상 그린다.
 */
const HospitalScheduleTable = ({ weeklySchedules }: HospitalScheduleTableProps) => {
  const { schedule: todaySchedule } = useHospitalSchedule(weeklySchedules)
  if (weeklySchedules.length === 0) return null

  return (
    <ul className="grid grid-cols-1 gap-x-8 gap-y-1.5 sm:grid-cols-2">
      {weeklySchedules.map((schedule) => {
        const isToday = schedule.dayType === todaySchedule?.dayType
        return (
          <li
            key={schedule.dayType}
            className={`flex items-center justify-between gap-4 rounded-lg px-3 py-1.5 ${
              isToday ? "bg-primary-50" : ""
            }`}
          >
            <Typography
              as="span"
              size={14}
              lineHeight={20}
              className={isToday ? "font-semibold text-primary-700" : "text-gray-600"}
            >
              {stripDaySuffix(schedule.dayType)}
            </Typography>
            <Typography
              as="span"
              size={14}
              lineHeight={20}
              className={`tabular-nums ${isToday ? "font-semibold text-primary-700" : "text-gray-700"}`}
            >
              {schedule.startTime} - {schedule.endTime}
            </Typography>
          </li>
        )
      })}
    </ul>
  )
}

export default HospitalScheduleTable
